/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::254da005ee62004d45537995770eba56>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */

function createEventPayload(eventKey, attributes) {
  var event = eventKey.split('.');
  return {
    eventType: event[0],
    actionSubject: event[1],
    action: event[2],
    actionSubjectId: event[3],
    attributes: attributes
  };
}
export default createEventPayload;